document.addEventListener('DOMContentLoaded', function() {
  // ==========================================================================
  // Mobile Navigation Drawer Toggle
  // ==========================================================================
  const menuOpenBtn = document.getElementById('MenuOpenBtn');
  const menuCloseBtn = document.getElementById('MenuCloseBtn');
  const mobileDrawer = document.getElementById('MobileDrawer');
  const mobileDrawerOverlay = document.getElementById('MobileDrawerOverlay');

  function openDrawer() {
    if (mobileDrawer) {
      mobileDrawer.classList.add('active');
      mobileDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
  }

  function closeDrawer() {
    if (mobileDrawer) {
      mobileDrawer.classList.remove('active');
      mobileDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  if (menuOpenBtn) menuOpenBtn.addEventListener('click', openDrawer);
  if (menuCloseBtn) menuCloseBtn.addEventListener('click', closeDrawer);
  if (mobileDrawerOverlay) mobileDrawerOverlay.addEventListener('click', closeDrawer);

  // Close drawer on ESC key press
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('active')) {
      closeDrawer();
    }
  });


  // ==========================================================================
  // Product Page Image Switcher
  // ==========================================================================
  const mainImage = document.getElementById('ProductMainImage');
  const thumbnailBtns = document.querySelectorAll('.product-page__thumbnail-btn');

  thumbnailBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      // Remove active class from all thumbnails
      thumbnailBtns.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked thumbnail
      this.classList.add('active');

      // Update main image src
      const newImageUrl = this.getAttribute('data-image-url');
      if (mainImage && newImageUrl) {
        mainImage.src = newImageUrl;
      }
    });
  });


  // ==========================================================================
  // Product Form Quantity Picker
  // ==========================================================================
  const quantityInput = document.getElementById('Quantity');
  const decrementBtn = document.querySelector('.quantity-picker__btn.decrement');
  const incrementBtn = document.querySelector('.quantity-picker__btn.increment');

  if (quantityInput) {
    if (decrementBtn) {
      decrementBtn.addEventListener('click', function() {
        let currentValue = parseInt(quantityInput.value, 10);
        if (!isNaN(currentValue) && currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });
    }

    if (incrementBtn) {
      incrementBtn.addEventListener('click', function() {
        let currentValue = parseInt(quantityInput.value, 10);
        if (!isNaN(currentValue)) {
          quantityInput.value = currentValue + 1;
        }
      });
    }
  }


  // ==========================================================================
  // Shopify AJAX Dynamic variant selector handling (Basic outline)
  // ==========================================================================
  const variantSelectors = document.querySelectorAll('.product-form .custom-select');
  if (variantSelectors.length > 0) {
    // Collect all variants data from theme JSON if needed or basic setup.
    // In a fully-formed Shopify theme, you would query variant products dynamically.
  }

  // ==========================================================================
  // Accordion Toggle
  // ==========================================================================
  const accordionHeaders = document.querySelectorAll('.accordion__header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.parentElement;
      const content = this.nextElementSibling;
      
      // Close other items
      const siblingItems = item.parentElement.querySelectorAll('.accordion__item');
      siblingItems.forEach(sibling => {
        if (sibling !== item && sibling.classList.contains('active')) {
          sibling.classList.remove('active');
          sibling.querySelector('.accordion__content').style.maxHeight = null;
        }
      });

      // Toggle current item
      if (item.classList.contains('active')) {
        item.classList.remove('active');
        content.style.maxHeight = null;
      } else {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });

  // ==========================================================================
  // Mobile Sticky Buy Bar Scroll Trigger
  // ==========================================================================
  const mainBuyBtn = document.querySelector('.product-form__buttons');
  const stickyBuyBar = document.getElementById('StickyBuyBar');

  if (mainBuyBtn && stickyBuyBar) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // If the main buy button is NOT visible in viewport, show the sticky buy bar
        if (!entry.isIntersecting) {
          stickyBuyBar.classList.add('visible');
        } else {
          stickyBuyBar.classList.remove('visible');
        }
      });
    }, {
      root: null,
      threshold: 0
    });

    observer.observe(mainBuyBtn);
  }

  // ==========================================================================
  // Coming Soon Countdown Timer
  // ==========================================================================
  const countdownEl = document.getElementById('ComingSoonCountdown');
  if (countdownEl) {
    const targetDateStr = countdownEl.getAttribute('data-date');
    if (targetDateStr) {
      const targetTime = new Date(targetDateStr).getTime();

      const daysVal = document.getElementById('days');
      const hoursVal = document.getElementById('hours');
      const minutesVal = document.getElementById('minutes');
      const secondsVal = document.getElementById('seconds');

      function updateCountdown() {
        const now = new Date().getTime();
        const difference = targetTime - now;

        if (difference < 0) {
          if (daysVal) daysVal.innerText = '00';
          if (hoursVal) hoursVal.innerText = '00';
          if (minutesVal) minutesVal.innerText = '00';
          if (secondsVal) secondsVal.innerText = '00';
          return;
        }

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        if (daysVal) daysVal.innerText = days < 10 ? '0' + days : days;
        if (hoursVal) hoursVal.innerText = hours < 10 ? '0' + hours : hours;
        if (minutesVal) minutesVal.innerText = minutes < 10 ? '0' + minutes : minutes;
        if (secondsVal) secondsVal.innerText = seconds < 10 ? '0' + seconds : seconds;
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  }
});
